import { Routes, Route } from "react-router-dom";
import Home from "./home";
import Navbar from "./navbar";

function Router() {
  return (
    <>
      <Navbar />
      <div className="pt-0">
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </>
  );
}

export default Router;
